import { render, staticRenderFns } from "./PscsNotification.vue?vue&type=template&id=131ffdea"
import script from "./PscsNotification.vue?vue&type=script&lang=js"
export * from "./PscsNotification.vue?vue&type=script&lang=js"
import style0 from "./PscsNotification.vue?vue&type=style&index=0&id=131ffdea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports